import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';

type GuardOptions = {
	requireUser?: boolean;
	requireNoUser?: boolean;
	redirectTo?: string;
};

export const withAuthGuard = (
	element: JSX.Element,
	{ requireUser, requireNoUser, redirectTo }: GuardOptions = {}
): JSX.Element => {
	const user = getAuth().currentUser;

	if (requireUser && !user) {
		return <Navigate to={redirectTo ?? '/welcome'} replace />;
	}

	if (requireNoUser && user) {
		return <Navigate to={redirectTo ?? '/home'} replace />;
	}

	return element;
};
